var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category_banner",style:(_vm.getStyle(_vm.getCategory))},[_c('div',{staticClass:"category_textes"},[_c('h2',[_vm._v(_vm._s(_vm.$t(_vm.getCategory.name)))]),_c('p',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.$t(_vm.getCategory.description)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }